/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Module, w, SCS, scsHeader) {
	'use strict';

	var deparam = require('lib/vendor/jquery-deparam-patched').default;

	/**
	 * Rating form component
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class RatingsForm
	 * @extends Tc.Module
	 */
	Module.RatingForm = Module.extend({
		// Shortcut. True if the view mode is mobile.
		isMobile: false,

		// The product family model instance
		family: null,

		/**
		 * Module vars
		 */

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.isMobile = SCS.utils.isMobilePage();

			// Rating select
			mod.ratingStarSelect();

			// Subscribe to products private channel and get data
			mod.sandbox.subscribe('dynamicProducts', mod);
			mod.sandbox.subscribe('rarev', mod);

			mod.$subRatingsWrapper = mod.$ctx.find('.sub-ratings-wrapper');

			mod.createEventHandler();

			this.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(mod, mod.updateFamily);

			callback();
		},

		createEventHandler: function () {
			var mod = this;
			mod.$form = mod.$ctx.find('.modScForm > form');
			// Submit rating
			mod.$form.on('submit', $.proxy(mod.onSubmit, mod));

			// Cancel rating
			mod.$form.on('reset', $.proxy(mod.onCancel, mod));
		},

		// Submit rating
		onSubmit: function (e) {
			var mod = this;
			e.preventDefault();
			e.stopImmediatePropagation();

			if (mod.validateForm()) {
				mod.$form.find('.button-indent').addClass('scs-loadingRotator');
				mod.postReview();
			}
		},

		// Cancel rating
		onCancel: function (e) {
			var mod = this;
			e.preventDefault();

			if (mod.isMobile) {
				if (mod.mobileDialog) {
					mod.mobileDialog.close();
				}
			} else {
				mod.$ctx.dialog('close');
			}

			mod.onAddTracking('cancel');
		},

		/**
		 * Callback function from hub
		 * @param subRatingCategories
		 */
		updateFamily: function updateFamily(data) {
			var mod = this;

			var family = mod.family = data.family;
			var id = family.getId();
			var ratings = family.getRatings();
			if(!ratings.loaded()) {
				// Register callback for when rating data is loaded
				ratings.load().done($.proxy(updateFamily, mod, data));
				return;
			}

			// Add first product ID
			if(!id) {
				mod.log('Data from overview module doesn’t have product ID');
				return false;
			}

			mod.setTitle(family.getFamilyName());

			// Update subrating categories
			var categories = ratings.getSubRatingCategories().getCategories();
			mod.updateSubratingCategories(categories);

			// Show form button
			mod.fire('showFormButton', {show: !mod.checkPreviousRatings(id)}, ['dynamicProducts']);
		},

		updateSubratingCategories: function(categories) {
			var $ctx = this.$ctx;

			$ctx.find('.sub-ratings-wrapper > a').remove();
			$ctx.find('.sub-ratings-wrapper').addClass('hidden');

			if(!categories.length) {
				return;
			}

			var $subRatings = $(document.createDocumentFragment());
			var $star = $('<span/>', {'class': 'empty'});

			$.each(categories, function(i, category) {
				var $stars = $([1, 2, 3, 4, 5].map(function() {
					return $star.clone()[0];
				}));
				var $category = $('<a/>', {
					prop: {
						href: '#'
					},
					'class': 'rating-stars sub-ratings',
					data: {
						subratingId: category.getId()
					}
				});
				$category.append($stars).append($('<span/>').text(category.getName()||''));
				if(this.isMobile) {
					$category = $category.wrap('<span/>');
				}
				$subRatings.append($category[0]);
			});

			$ctx.find('.sub-ratings-wrapper').removeClass('hidden').append($subRatings);
		},

		/**
		 * Get data from overview module and prepare form
		 *
		 * @param formData {Object} Object data from overview module
		 */
		onGetDataFromParent: function(data) {
			this.setTitle(data.title);
		},

		setTitle: function(title) {
			var $title = this.$ctx.find('h2 > span');
			if(!title) {
				$title.text('');
			} else {
				$title.text(' '+title);
			}
		},

		/**
		 * Happens when opening the form
		 *
		 * @param @button {Object} Open form button
		 */
		onOpenRatingForm: function () {
			var mod = this,
				dialogTitle = mod.$ctx.data('dialog-title');

			if (mod.isMobile) {

				mod.mobileDialog = SCS.createNewMobilePage({
					content: mod.$ctx.removeClass('hidden'),
					cssClass: 'rating-form',
					noContentInit: true,
					destroyOnClose: true,
					reuseContent: true
				});

				mod.resetFormValidation();

			} else {
				mod.resetFormValidation();
				mod.$ctx.dialog({
					width: 470,
					maxWidth: 470,
					classes: {'ui-dialog': 'rating-form'},
					title: dialogTitle
				});
			}
		},

		/**
		 * Rating stars selection method
		 */
		ratingStarSelect: function () {
			var mod = this,
				$ctx = mod.$ctx;


			if (mod.isMobile) {
				$ctx.on('click', '.rating-stars > .empty', function (e) {
					e.stopPropagation();
					e.preventDefault();
					var $star = $(this),
						$starParent = $star.parent();

					$starParent.children().removeClass('click');

					// Add star number to parent data
					$starParent.data('product-rating', $star.index() + 1);

					// Finally add click class
					$star.addClass('click');

					$star.prevAll().addClass('selected');
					$star.addClass('selected');
					$star.nextAll().removeClass('selected');

				});
			} else {
				$ctx.on('mouseenter', '.rating-stars > .empty', function (e) {
					e.stopPropagation();
					var $star = $(this),
						$previousStars = $star.prevAll(),
						$nextStars = $star.nextAll();

					$previousStars.addClass('selected');
					$nextStars.removeClass('selected');

				});

				$ctx.on('mouseleave', '.rating-stars > .empty', function (e) {
					e.stopPropagation();
					var $star = $(this),
						$parent = $star.parent(),
						$selected = $parent.find('.click');

					$parent.children().removeClass('selected');


					if ($selected && $selected.length) {
						$selected.prevAll().addClass('selected');
						$selected.addClass('selected');
						$selected.nextAll().removeClass('selected');
					}

				});

				$ctx.on('click', '.rating-stars > .empty', function (e) {
					e.stopPropagation();
					e.preventDefault();
					var $star = $(this),
						$starParent = $star.parent();

					$starParent.children().removeClass('click');

					// Add star number to parent data
					$starParent.data('product-rating', $star.index() + 1);

					// Finally add click class
					$star.addClass('click');
				});
			}


		},

		/**
		 * Validates comment form
		 *
		 * @param $submitButton {Object} Form submit button
		 */
		validateForm: function () {
			var $ctx = this.$ctx,
				$ratingSelect = $ctx.find('.rating-select > a'),
				$fields = $ctx.find('.modScForm form > .field'),
				validates = true,
				clientValidation,
				clientValidationInstance;

			// Check rating selection
			if (isNaN(parseInt($ratingSelect.data('product-rating'), 10))) {
				$ratingSelect.addClass('error');
				validates = false;
			} else if ($ratingSelect.hasClass('error')) {
				$ratingSelect.removeClass('error');
			}

			// Check for form input fields
			for (var i = 0, ii = $fields.length; i < ii; i += 1) {
				var $field = $fields.eq(i),
					$inputs = $field.find('input[data-validate!="false"], textarea[data-validate!="false"]'),
					val = $inputs.val(),
					type = $inputs.attr('type');

				clientValidation = w.ScForm.createClientValidation($field.data('clientvalidation'));
				$field.data('invalid', false);

				if (type === 'radio') {
					clientValidationInstance = clientValidation.
						validateRadioGroup($field.find('input:radio:checked').length);
				} else {
					clientValidationInstance = clientValidation.validate(val);
				}

				if (clientValidationInstance.isValid) {
					$field.find('input, textarea').removeClass('error-field');
					$field.removeClass('error');
					$field.find('.error').addClass('hidden');
					$field.data('invalid', false);
				} else {
					$field.find('.error').html(clientValidation.constraintMessage).removeClass('hidden');
					$field.find('input, textarea').addClass('error-field');
					$field.addClass('error');
					$field.data('invalid', true);
					validates = false;
				}
			}

			return validates;
		},


		resetFormValidation: function () {
			var $ctx = this.$ctx;
			$ctx.find('.modScForm > .field').removeClass('error');
			$ctx.find('input, textarea').removeClass('error-field');
			$ctx.find('.rating-select > a').removeClass('error');
			$ctx.find('.error').addClass('hidden');

		},

		/**
		 * Prepare data fro eCommerce
		 */
		// FIXME NEC: Adapt to new endpoint
		postReview: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$ratingSelect = $ctx.find('.rating-select > a');

			var data = deparam(mod.$form.serialize());

			var postData = {
				// FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
				rating: parseInt($ratingSelect.data('product-rating'), 10) * 10,
				productId: mod.family.getId(),
				firstName: data.FirstName,
				lastName: data.LastName,
				email: data.Email,
				comment: data.Comment,
				date: w.moment().format('YYYY-MM-DDTHH:mm:ssZZ'),
				// FIXME NEC: Route this through
				ipAddress: '0.0.0.0',
				language: $('html').attr('lang'),
				headline: data.Title,
				// FIXME NEC: Use correct enum values
				recommended: data.Recommendation,
				subratings: $ctx.find('.sub-ratings-wrapper > a').map(function() {
					var $subRatings = $(this);
					return {
						category: {
							id: $subRatings.data('subrating-id')
						},
						// FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
						rating: parseInt($subRatings.data('product-rating'), 10) * 10
					};
				}).get().filter(function(subrating) {
					return !!subrating.rating;
				})
			};

			// Finally send the data to eCommerce
			mod.sendData(postData);
		},

		/**
		 * Post rating & review to eCommerce
		 *
		 * @param data {Object}
		 */
		sendData: function (data) {
			var mod = this,
				$ctx = mod.$ctx;

			var endpoint = SCS.utils.formatString(mod.$form.attr('action'), mod.family.getId());

			var $error = $ctx.find('.headingError');
			var $errorMsg = $error.find('> .msg');

			// Send the data
			$.ajax({
				url: endpoint,
				type: 'POST',
				dataType: 'json',
				contentType: 'application/json',
				data: w.JSON.stringify(data),
				success: function() {
					mod.checkPreviousRatings(data.productId, true);
					mod.onAddTracking('save');
					mod.resetForm();
					mod.fire('formSuccessSubmit', {}, ['dynamicProducts']);
					mod.fire('showFormButton', {
						show: false,
						success: true
					}, ['dynamicProducts']);

					// Hide form
					if (mod.isMobile) {
						if (mod.mobileDialog) {
							mod.mobileDialog.close();
						}
					} else {
						$ctx.dialog('close');
					}
				},
				error: function (jqXHR) {
					var response;
					mod.log('Got error response', arguments);
					$error.removeClass('hidden');
					try {
						response = $.parseJSON(jqXHR.responseText).Error;
					} catch(e) {}
					if (response) {
						$errorMsg.html('<ul><li>' + response.Messages.join('</li><li>') + '</li></ul>');
					} else {
						$errorMsg.text($ctx.find('.modScForm').data('error-message'));
					}
				},
				statusCode: {
					409: function conflict() {
						mod.log('Got conflict response', arguments);
						// Conflict means the user has already submitted a review
						$errorMsg.text($ctx.data('error-message-duplicate-submit'));
					}
				},
				complete: function () {
					$ctx.find('.button-indent').removeClass('scs-loadingRotator');
				}
			});
		},

		/**
		 * Get updated product data from PMF
		 *
		 * @param productID {Integer} Product ID that visitor want to leave a r&r
		 * @param set {Boolean} Do we need to set product flag into storage
		 *
		 * @return {Boolean] Have visitor rated this product before
		 */
		checkPreviousRatings: function (productID, set) {
			if (!w.localStorage) {
				// Check does browser support local storage
				return false;
			}

			var productRatings = localStorage.getItem('scs-productRatings') || '{}';
			productRatings = w.JSON.parse(productRatings) || {};

			// Check do we need to set product flag
			if(set) {
				productRatings[productID] = true;
				// Sat data into storage
				localStorage.setItem('scs-productRatings', w.JSON.stringify(productRatings));
			}

			return productID in productRatings;
		},

		/**
		 * Reset form on successful rating submit
		 */
		resetForm: function () {
			var mod = this,
				$ctx = mod.$ctx;

			// Reset rating selection
			$ctx.find('.rating-stars > span').removeClass('selected click');

			// Reset title, comment and recommendation
			$ctx.find('input[name=Title], textarea[name=Comment]').val('');
			$ctx.find('input[name=Recommendation]').prop('checked', false);
			$ctx.find('label[for^=Recommendation]').removeClass('checked');
		},

		/**
		 * Track events in form
		 *
		 * @param action {String} Action to track
		 */
		onAddTracking: function (action) {
			// jshint camelcase: false
			var mod = this;


			mod.trackingTealium(action);
		},

		/**
		 * Tealium tracking
		 *
		 * @param action {String} Action to track
		 */
		trackingTealium: function (action) {
			// jshint camelcase: false
			SCS.portal.datalayer.trackEvent(action, 'r_ratingstars', 'content', 'Rating');
		}
	});


})(window.Tc.$, window.Tc.Module, window, window.SCS = window.SCS || {}, window.scsHeader = window.scsHeader || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RatingForm.js
// module id = 174
// module chunks = 0